import React, { PureComponent } from "react";
import { Select, Radio, Checkbox, Button } from "element-react";
import { List,Input } from "antd";
import { Link } from "react-router-dom";

import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import Navigation from "../../components/navigation";

import add from "../../images/add.png";
import minus from "../../images/minus.png";
import "./index.scss";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      listData: [
        {id: 1,serviceName: '职业技能培训'},
        {id: 2,serviceName: '适应性培训'},
        {id: 3,serviceName: '个性化培训'},
        {id: 4,serviceName: '其他培训'},
      ],
      children: [
        {id: 1,itemName: '培训',sid: 1},
      ],
      showChildren: false,
      showid: 0,
    };
  }

  componentDidMount() {
    
  }

  handleChildren = (id) => {
    const { showChildren, showid, children } = this.state;
    if (showChildren&&showid==id) {
      this.setState({
        showChildren: !showChildren,
        showid: id,
      })
    } else if (showChildren && showid != id) {
      this.setState({
        children: children,
        showid: id,
      })
    } else {
      this.setState({
        showChildren: !showChildren,
        children: children,
        showid: id,
      })
    }
  }

  render() {
    const { listData,showChildren,showid,children } = this.state;
    return (
      <div className="life">
        <Navigation />
        <div className="header">
          <span className="title">就业</span>
        </div>
        <List
          itemLayout="vertical"
          size="large"
          pagination={{
            onChange: page => {
              console.log(page);
            },
            pageSize: 5,
          }}
          style={{ marginBottom: 15,minHeight: 350}}
          //, marginTop: 15
          className="elist"
          dataSource={listData}
          renderItem={item => (
            <List.Item
              key={item.id}
              style={{ padding: 0, paddingBottom: 16, display: 'block', borderBottom: 'none' }}
              // paddingTop: 16, 
            >
              <div className="searchOpt listheader" onClick={() => this.handleChildren(item.id)}>
                {showChildren&&showid==item.id ? <img className="icon" src={minus} alt="" /> : <img className="icon" src={add} alt="" />}
                <text>{item.serviceName}</text>
              </div>
              <div style={{width: '100%',marginBottom: '15px', display: showChildren&&showid==item.id ? "block" : "none"}}>
                <List
                  itemLayout="vertical"
                  size="large"
                  dataSource={children}
                  renderItem={item => (
                    <List.Item
                      key={item.id}
                      actions={[<Button className="list-button">办事指南</Button>, <Button className="list-button" style={{borderRadius: '7%'}}>在线办理</Button>]}
                    >
                      {/* disabled={true}  */}
                      <div className="icon-disc"></div>
                      {item.itemName}
                    </List.Item>
                  )}
                />
              </div>
            </List.Item>
          )}
        >
        </List>
      </div>
    );
  }
}
